import React from "react"
import {Alert, Grid, Link} from "@mui/material"

import type {LatitudeInfo} from "@indebted/api"

type LatitudePanelProps = {
	systemOfRecord: string
	latitude: LatitudeInfo | null
}

// The warning and the Latitude details are gated separately. Converting a
// customer hands ownership to Collect and flips the system of record, at which
// point acting in Rocket is correct — so the warning goes. The details stay
// available for as long as the account carries a Latitude ID, which it does
// for good: it is the historical key into Latitude's system.
function LatitudePanel({systemOfRecord, latitude}: LatitudePanelProps) {
	const latitudeOwnsCustomer = systemOfRecord === "Latitude"

	if (!latitudeOwnsCustomer && !latitude) {
		return null
	}

	return (
		<Grid container style={{marginBottom: "16px"}}>
			<Grid size={12}>
				<Alert severity={latitudeOwnsCustomer ? "warning" : "info"}>
					{latitudeOwnsCustomer && (
						<>
							This is a Latitude customer. No action should be taken in Rocket.
							{latitude && " "}
						</>
					)}
					{latitude && (
						<>
							{latitude.Link && (
								<Link href={latitude.Link} target="_blank" rel="noopener noreferrer">
									View in Latitude
								</Link>
							)}
							<br />
							Collection Comms Enabled: {latitude.CollectionCommsEnabled ? "Yes" : "No"}
							<br />
							Payments Enabled: {latitude.PaymentsEnabled ? "Yes" : "No"}
						</>
					)}
				</Alert>
			</Grid>
		</Grid>
	)
}

export {LatitudePanel}
